var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVkontakte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M9.883 13.958s.325-.035.49-.21c.153-.16.148-.46.148-.46s-.02-1.405.65-1.612c.66-.204 1.51 1.36 2.41 1.96.68.454 1.194.355 1.194.355l2.404-.032s1.258-.075.662-1.038c-.05-.08-.348-.712-1.788-2.014-1.508-1.362-1.305-1.142.51-3.5 1.106-1.434 1.548-2.31 1.41-2.685-.13-.357-.945-.262-.945-.262l-2.706.017s-.2-.027-.35.06c-.144.084-.24.282-.24.282s-.426 1.11-.997 2.055c-1.206 1.993-1.687 2.098-1.884 1.975-.46-.29-.346-1.16-.346-1.777 0-1.932.3-2.737-.585-2.945-.295-.07-.51-.115-1.265-.123-.965-.01-1.782.004-2.245.224-.308.147-.546.474-.4.493.178.022.583.105.798.39.277.368.267 1.192.267 1.192s.16 2.274-.372 2.556c-.365.194-.865-.2-1.94-2.01-.55-.925-.965-1.95-.965-1.95s-.08-.19-.224-.293c-.173-.124-.416-.163-.416-.163l-2.57.016s-.388.01-.53.174c-.125.145-.01.446-.01.446s2.014 4.588 4.295 6.9c2.09 2.12 4.464 1.98 4.464 1.98h1.076z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkontakte);
export default __webpack_public_path__ + "static/media/vkontakte.076a1d2249835715e5cc3de6f7ff7d63.svg";
export { ForwardRef as ReactComponent };